"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ProteusError_1 = require("./ProteusError");
var InputError = (function (_super) {
    __extends(InputError, _super);
    function InputError(message, code) {
        if (message === void 0) { message = 'Invalid input'; }
        if (code === void 0) { code = 4; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, InputError.prototype);
        return _this;
    }
    InputError.CODE = {
        CASE_400: 400,
        CASE_401: 401,
        CASE_402: 402,
        CASE_403: 403,
        CASE_404: 404,
        CASE_405: 405,
        CASE_406: 406,
        CASE_407: 407,
        CASE_408: 408,
        CASE_409: 409,
    };
    return InputError;
}(ProteusError_1.default));
var RangeError = (function (_super) {
    __extends(RangeError, _super);
    function RangeError(message, code) {
        if (message === void 0) { message = 'Invalid array length'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, RangeError.prototype);
        return _this;
    }
    return RangeError;
}(InputError));
var TypeError = (function (_super) {
    __extends(TypeError, _super);
    function TypeError(message, code) {
        if (message === void 0) { message = 'Invalid type'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, TypeError.prototype);
        return _this;
    }
    return TypeError;
}(InputError));
var ConversionError = (function (_super) {
    __extends(ConversionError, _super);
    function ConversionError(message, code) {
        if (message === void 0) { message = 'Conversion error'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, TypeError.prototype);
        return _this;
    }
    return ConversionError;
}(InputError));
Object.assign(InputError, {
    RangeError: RangeError,
    TypeError: TypeError,
    ConversionError: ConversionError,
});
exports.default = InputError;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/errors/InputError.js
// module id = 13
// module chunks = 0 1